export const POLITICAS_Y_PROTECCION = [
  {
    title: "POLÍTICA DE CONFIDENCIALIDAD Y PROTECCIÓN DE DATOS",
    content:
      "Valoramos la confianza que depositas en nosotros al utilizar nuestros productos y queremos que estés al tanto de como manejamos tus datos personales.",
  },
  {
    title: "",
    content:
      "Mediante la utilización de los sitios y los servicios digitales de Asegura Más, aceptas nuestra política de Privacidad. En caso de no estar de acuerdo con la misma, por favor, no utilices estos Sitios. Si vos utilizas algún Sitio luego de que se haya introducido alguna modificación a esta política, ello importará la aceptación de los cambios",
  },
  {
    title: "",
    content:
      "Desde Asegura Más recolectamos tu información personal para que puedas disfrutar de nuestros servicios y mejorarlos de manera continua para que puedas animarte a más. Recibimos y almacenamos tu información personal que facilitas vos mismo cuando utilizas o adquirís alguno de nuestros servicios o productos.",
  },
  {
    title: "",
    content:
      "Nuestra política se aplica solo a los Sitios y servicios digitales propiedad de Asegura Más, no así a los sitios a los que vos accedas por medio de links. Te sugerimos que en estos casos te informes acerca de la política adoptada en cada uno de los sitios.",
  },
  {
    title: "",
    content:
      "Desde Asegura Más resguardamos a salvo y conforme a niveles de protección adecuados, toda la información que los visitantes provean.",
  },
  {
    title: "",
    content:
      "Podremos utilizar la información provista por vos con fines promocionales, publicitarios y/o estadísticos. Implementamos medidas de seguridad administrativas, técnicas y físicas para proteger tus datos personales ante la destrucción, pérdida, alteración, acceso, comunicación o uso accidental, ilegal o no autorizado. Sus datos serán procesados siempre en cumplimiento de las finalidades declaradas, de acuerdo con el tipo de servicio requerido. Para poder llevar adelante la prestación de nuestros servicios, así como el mejoramiento de la experiencia del servicio, necesitamos transferir tus datos a distintos tipos de destinatarios. En todos los casos, dichas transferencias serán realizadas de acuerdo a los límites y finalidades establecidas contractualmente, advirtiendo siempre sobre la obligatoriedad de tomar los recaudos de seguridad y confidencialidad adecuadas.",
  },
  {
    title: "",
    content:
      "Tenes la facultad de ejercer el derecho de acceso a tus datos en forma gratuita a intervalos no inferiores a seis meses, salvo que se acredite un interés legítimo al efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley Nº 25.326.",
  },
  {
    title: "",
    content:
      "La DIRECCION NACIONAL DE PROTECCION DE DATOS PERSONALES, Órgano de Control de la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se interpongan con relación al incumplimiento de las normas sobre protección de datos personales",
  },
];
